module.exports = __webpack_public_path__ + "img/wuerzburg_residenz.c01bad8f.jpg";